import {
  type GetWorkerResponse,
  workerProfileAttributes,
} from "@clipboard-health/contract-worker-app-bff";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useUpdateWorkerCache } from "@src/appV2/Worker/useUpdateWorkerCache";
import { useMutation } from "@tanstack/react-query";

const SET_NOTIFICATION_POP_UP_SHOWN_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentProfile/setNotificationAlertShown`;

export function useSetNotificationPopUpShown() {
  const updateWorkerCache = useUpdateWorkerCache();
  return useMutation({
    mutationFn: async () => {
      const response = await post<Record<string, unknown>, GetWorkerResponse["data"]["attributes"]>(
        {
          url: SET_NOTIFICATION_POP_UP_SHOWN_URL,
          responseSchema: workerProfileAttributes,
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      updateWorkerCache({ ...data });
    },
  });
}
